import * as tslib_1 from "tslib";
import * as React from 'react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
// Remark: We have to share css file with MailListItem since we need to trigger child hover selectors
// off of the MailListItem container css class
var classNames = require('classnames/bind').bind();
/*
Renders the bar for both action icons and property icons
Note: This is a pure presentational component, and as such renders only based on passed in props
and do not observe the mobX store
*/
var IconBar = /** @class */ (function (_super) {
    tslib_1.__extends(IconBar, _super);
    function IconBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconBar.prototype.renderPropertyIcons = function () {
        var _this = this;
        var propertyIconElements = [];
        this.props.propertyIcons.forEach(function (propertyIcon) {
            var iconClasses = classNames(_this.props.iconClass, _this.props.propertyIconClass, propertyIcon.iconClasses);
            propertyIconElements.push(React.createElement("span", { key: propertyIcon.key, className: iconClasses }));
        });
        return propertyIconElements;
    };
    IconBar.prototype.renderHoverIcons = function () {
        var _this = this;
        var hoverIconElements = [];
        this.props.hoverActionIcons.forEach(function (hoverActionIcon) {
            var iconClasses = classNames(_this.props.iconClass, _this.props.hoverIconClass);
            hoverIconElements.push(React.createElement(IconButton, { key: hoverActionIcon.key, iconProps: hoverActionIcon.iconProps, onClick: function (evt) {
                    evt.stopPropagation();
                    hoverActionIcon.onClickCommand();
                }, onDoubleClick: function (evt) {
                    evt.stopPropagation();
                }, onRenderMenuIcon: function () { return null; }, styles: { icon: iconClasses }, className: iconClasses, title: hoverActionIcon.title, ariaLabel: hoverActionIcon.title, menuProps: hoverActionIcon.menuProps }));
        });
        return hoverIconElements;
    };
    IconBar.prototype.render = function () {
        var containerClassNames = classNames(this.props.backgroundColorClassName, this.props.iconBarContainerClass);
        return (React.createElement("div", { className: containerClassNames },
            this.props.hoverActionIcons && this.renderHoverIcons(),
            this.renderPropertyIcons()));
    };
    return IconBar;
}(React.Component));
export default IconBar;
//# sourceMappingURL=IconBar.js.map